import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from '../constants/app.constants';
import { OrderSummaryResponse } from '../components/model/ordersummaryresponse';
import { OrderDetailsResponse } from '../components/model/orderdetailsresponse';
import { Page } from '../components/model/pagination/page'
import { OrderdetailsComponent } from '../components/order-summary/orderdetails/orderdetails.component';
import { ReceiptDiscrepancy } from '../components/model/receipt-discrepancy';
import { AdvanceSearchDto } from '../components/model/advance-search-dto';
@Injectable({
  providedIn: 'root'
})
export class PoOrderDataServiceService {

  constructor(private httpClient: HttpClient) { }

  orderDetailsResponse:OrderDetailsResponse;
  advanceSearchResponse:Observable<Page<OrderSummaryResponse>>; 

  getPOSummaryDataByStore(storeNumber :string,poStatus: string, sort: string, order: string, pageNumber: number,pageSize:number): 
  Observable<Page<OrderSummaryResponse>> {
    if(sort===undefined){
      sort='';
     }
    return this.httpClient.get<Page<OrderSummaryResponse>>
    (AppConstants.GET_PURCHASE_ORDER_DATA + "?storeNumber="+storeNumber+"&poStatus="+poStatus+"&pageNo="+pageNumber+"&pageSize="+pageSize+"&sort="+sort+"&order="+order);
  }

  getPOSummaryDataByDC(dcNumber :number,poStatus: string, sort: string, order: string, pageNumber: number,pageSize:number): 
  Observable<Page<OrderSummaryResponse>> {
    if(sort===undefined){
     sort='';
    }
    return this.httpClient.get<Page<OrderSummaryResponse>>
    (AppConstants.GET_DC_PURCHASE_ORDER_DATA + "?dcNumber="+dcNumber+"&poStatus="+poStatus+"&pageNo="+pageNumber+"&pageSize="+pageSize+"&sort="+sort+"&order="+order);
  }

  approveOC(sequenceNumber :number,userSeqNumber:number,po_extensiton:any): 
  Observable<number> {
    return this.httpClient.put<number>
    (AppConstants.APPPORVE_OC_PURCHASE_ORDER_DATA + "?sequenceNumber="+sequenceNumber+"&userSeqNumber="+userSeqNumber,po_extensiton);
  }

  updatePODetails(sequenceNumber :number,receiptDiscrepancy:ReceiptDiscrepancy): 
  Observable<number> {
    return this.httpClient.put<number>
    (AppConstants.UPDATE_PURCHASE_ORDER_DATA +"/"+sequenceNumber,receiptDiscrepancy);
  }


  approveRC(sequenceNumber :number,receivedDate,status,userSeqNumber:number,po_extensiton:any): 
  Observable<number> {
    return this.httpClient.put<number>
    (AppConstants.APPROVE_RC_PURCHASE_ORDER_DATA + "?sequenceNumber="+sequenceNumber+"&approveDate="+receivedDate+"&status="+status+"&userSeqNumber="+userSeqNumber,po_extensiton);
  }

  removePOReportedDetails(sequenceNumber :number): 
  Observable<number> {
  return this.httpClient.put<number>(AppConstants.REMOVE_REPORT_PURCHASE_ORDER_DATA +"/"+sequenceNumber,null);
  }

 


  getPODetailsData(posequencenumber:number): 
  Observable<OrderDetailsResponse> {
    return this.httpClient.get<OrderDetailsResponse>(AppConstants.GET_PURCHASE_ORDER_DETAILS_DATA+"?sequenceNumber="+encodeURIComponent(posequencenumber));
    
  }


  getPoDetailsById(oderDetailsResponse:OrderDetailsResponse){
  this.orderDetailsResponse=oderDetailsResponse;
  }

  advanceSearch(advanceSearch:AdvanceSearchDto): 
  Observable<Page<OrderSummaryResponse>> {
    return this.httpClient.post<Page<OrderSummaryResponse>>
    (AppConstants.ADVANCE_SEACH,advanceSearch);
  }

  advanceSearchMain(advanceSearch:AdvanceSearchDto){
 return  this.advanceSearchResponse= this.httpClient.post<Page<OrderSummaryResponse>>(AppConstants.ADVANCE_SEACH,advanceSearch);
  }
}
